import type ServiceJson from './service_json';

export type ServiceResponseArgs = ServiceJson;

export type ServiceArgs = {
  id: number;
  tel?: string;
  opsTel: string;
  consignmentSaleTel: string;
};

export const convertServiceResponseToArgs = (response: ServiceResponseArgs): ServiceArgs => {
  return {
    id: response.id,
    tel: response.tel,
    opsTel: response.ops_tel,
    consignmentSaleTel: response.consignment_sale_tel
  };
};

export default class Service {
  id: number;
  tel?: string;
  opsTel: string;
  consignmentSaleTel: string;

  constructor(args: ServiceArgs) {
    this.id = args.id;
    this.tel = args.tel;
    this.opsTel = args.opsTel;
    this.consignmentSaleTel = args.consignmentSaleTel;
  }
}
